/* eslint-disable react/forbid-prop-types */
import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { sieauTooltip } from '../../utils/FormUtils'
import { hasValue } from 'utils/NumberUtil'

// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated use Icon from MUI
 */
const Icon = forwardRef(({
    size = '',
    className = '',
    tooltip = '',
    tooltipPosition = 'top',
    children,
    icon = '',
    onClick = () => {},
    clickable = true,
    style = {},
    'data-cy': dataCy,
}, ref) => {
    const tooltipFormated = hasValue(tooltip) ? sieauTooltip(tooltip, undefined, tooltipPosition) : null
    return (
        <i
            style={{ ...style }}
            {...tooltipFormated}
            className={`material-icons ${clickable ? 'clickable' : ''} ${size} ${className}`}
            onClick={onClick}
            data-cy={dataCy}
            ref={ref}
        >
            {children || icon}
        </i>
    )
})

Icon.propTypes = {
    size: PropTypes.string,
    className: PropTypes.string,
    tooltip: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    tooltipPosition: PropTypes.oneOf(['top', 'bottom']),
    children: PropTypes.string, // depracated
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    clickable: PropTypes.bool,
    style: PropTypes.object,
    'data-cy': PropTypes.string,
}

export default Icon
